module.exports = __webpack_public_path__ + "img/AneuGuide.0a9da789.png";